import { useEffect, useState } from "react";

/** The phone layout's breakpoint. It is `theme.css`'s `@media (max-width: 760px)`,
 * repeated here because the header on a phone does not only lay out differently:
 * it renders different things (#1132). The build label is not in the header at
 * all, and a rule that only hid it would leave a second copy in the page. */
export const NARROW = "(max-width: 760px)";

/** Whether the window is at the phone layout, following it as it changes. A
 * browser without `matchMedia` reads as wide, which is what it always drew. */
export function useNarrow(): boolean {
  const [narrow, setNarrow] = useState(() => window.matchMedia?.(NARROW).matches ?? false);
  useEffect(() => {
    const q = window.matchMedia?.(NARROW);
    if (!q) return;
    const on = () => setNarrow(q.matches);
    on();
    q.addEventListener("change", on);
    return () => q.removeEventListener("change", on);
  }, []);
  return narrow;
}
